var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileguide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GLYPH",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m488 32h-412.305a31.98871 31.98871 0 0 0 -59.695 16v416a32.036 32.036 0 0 0 32 32h376a7.99977 7.99977 0 0 0 8-8v-40h56a7.99977 7.99977 0 0 0 8-8v-400a7.99977 7.99977 0 0 0 -8-8zm-440 0a16.01833 16.01833 0 0 1 16 16v384h-16a31.794 31.794 0 0 0 -16 4.30493v-388.30493a16.01833 16.01833 0 0 1 16-16zm432 400h-400v-384h400z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124 144a28 28 0 0 0 0 56h8a27.89157 27.89157 0 0 0 18.80957-7.27618 23.92471 23.92471 0 0 0 17.19043 7.27618v-16a8.00917 8.00917 0 0 1 -8-8v-40a32 32 0 0 0 -64 0h16a16 16 0 0 1 32 0v8zm8 40h-8a12 12 0 0 1 0-24h20v12a12.01375 12.01375 0 0 1 -12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211.92334 168h40.15332l12.38965 34.69092 15.06738-5.38184-40-112a7.99977 7.99977 0 0 0 -15.06738 0l-40 112 15.06738 5.38184zm20.07666-56.21436 14.3623 40.21436h-28.7246z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296 96h168v16h-168z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296 128h40v16h-40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352 128h112v16h-112z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296 160h88v16h-88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.34326 314.34326a7.99915 7.99915 0 0 0 0 11.31348l72 72a7.99945 7.99945 0 0 0 11.31348 0l56-56a7.99915 7.99915 0 0 0 0-11.31348l-44.14563-44.14563 6.194-22.7113a31.26119 31.26119 0 0 0 -30.15921-39.48633 31.39365 31.39365 0 0 0 -30.0586 22.67285l-10.6103 37.13672zm122.34326 21.65674-44.68652 44.68652-60.68652-60.68652 44.68652-44.68652 15.63165 15.63159-7.34991 26.95 15.43652 4.21 4.94428-18.12891zm-65.81445-84.93164a15.32527 15.32527 0 0 1 14.67383-11.06836 15.26084 15.26084 0 0 1 14.72265 19.27637l-3.78826 13.89038-14.82355-14.82349a8 8 0 0 0 -11.31348 0l-2.16955 2.16956z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120 400a24.02687 24.02687 0 0 0 24-24v-3.15576a23.92389 23.92389 0 0 0 -4.03076-13.3125l-13.313-19.96924a7.99959 7.99959 0 0 0 -13.3125 0l-13.31348 19.96973a23.92455 23.92455 0 0 0 -4.03026 13.31201v3.15576a24.02687 24.02687 0 0 0 24 24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384 320h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416 320h48v16h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384 352h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416 352h48v16h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384 384h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416 384h48v16h-48z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 80,
    rx: 8,
    width: 80,
    x: 384,
    y: 224
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288 320h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320 320h48v16h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288 352h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320 352h48v16h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288 384h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320 384h48v16h-48z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 80,
    rx: 8,
    width: 80,
    x: 288,
    y: 224
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileguide);
export default __webpack_public_path__ + "static/media/fileguide.2a9618465dd34e76f2fd85c91459fe91.svg";
export { ForwardRef as ReactComponent };